import React from 'react';
import { motion } from 'framer-motion';
export function JoinCTA() {
  return <section className="py-32 relative overflow-hidden bg-garage-surface border-t border-garage-border" data-id="element-112">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#F59E0B_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-113" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center" data-id="element-114">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-5xl md:text-7xl font-display font-bold text-garage-text mb-8 leading-tight" data-id="element-115">
          YOU DON'T NEED A LIFT.
          <br data-id="element-116" />
          <span className="text-garage-accent" data-id="element-117">YOU JUST NEED PASSION.</span>
        </motion.h2>

        <p className="text-xl text-garage-muted max-w-2xl mx-auto mb-12" data-id="element-118">
          Join thousands of enthusiasts building in driveways, carports, and
          shared spaces around the world.
        </p>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="px-10 py-5 bg-garage-accent hover:bg-garage-accent-hover text-black font-display font-bold text-xl tracking-wide uppercase rounded-sm shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] transition-all" data-id="element-119">
          Join Dead Pedal Garage
        </motion.button>
      </div>
    </section>;
}